// import {basicColors, retroColors,  electricColors} from "../../../style/basic/basicColors";
import { commonStyles } from "../../../theme/commonStyles";
export const journeyPlanMainStyles = {
  pageTitle: commonStyles.pageTitleStyle,

  pageTitleDetail: commonStyles.pageTitleDetailStyle,
};



// WEBPACK FOOTER //
// ./src/components/JourneyPlan/styles/Inspections.js